import { apiClient } from '@/api/client';
import { Filter } from '@/api/models';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { useEntityDrawer } from '@/hooks/useEntityDrawer';
import { queryKeys } from '@/lib/queryKeys';
import { FilterFormData } from '@/pages/filters/hooks/useFilterMutations';
import * as React from 'react';
import { FilterDrawer } from './components/FilterDrawer/index';
import { FiltersList } from './components/FiltersList';
import { useFilterMutations } from './hooks/useFilterMutations';

export const FiltersPage: React.FC = () => {
  const { state, actions } = useEntityDrawer<Filter>({
    basePath: '/filters',
    queryKey: queryKeys.ADMIN_FILTERS,
    fetchFn: async (id: number) => {
      const response = await apiClient.GET('/admin/filters/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to fetch filter');
      return response.data as Filter;
    },
    supportsCreate: true,
  });

  const {
    actions: mutationActions,
    isFormLoading,
    isDeleting,
  } = useFilterMutations();

  const handleFormSubmit = async (formData: FilterFormData) => {
    await mutationActions.handleFormSubmit(formData, state.mode, state.entity);
  };

  return (
    <DashboardLayout>
      <ProtectedRoute action='read' subject='Filter'>
        <FiltersList
          onRowClick={filter => actions.open(filter.id!)}
          onEditFilter={filter => actions.edit(filter.id!)}
          onDeleteFilter={mutationActions.handleDelete}
          onCreateFilter={actions.create}
          isDeleting={isDeleting}
        />

        <FilterDrawer
          onFormSubmit={handleFormSubmit}
          onDeleteFilter={mutationActions.handleDelete}
          isFormLoading={isFormLoading}
        />
      </ProtectedRoute>
    </DashboardLayout>
  );
};
